import { render } from "./BathSvg.vue?vue&type=template&id=8c4eeb76"
import script from "./BathSvg.vue?vue&type=script&lang=js"
export * from "./BathSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__